module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }